import { Divider } from "@mui/material";
import { isEmpty, size } from "lodash";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useUnderwritingHook } from "../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../redux/actions/loanDrilldownActions";
import { getUserFullNameFromEmail } from "../../../utils/functions/getUserFullNameFromEmail";
import RffForm from "../../finalForm/RffForm";
import RffDisplayField from "../../finalForm/inputs/RffDisplayField";
import RffSelectMultipleUserEmailField from "../../finalForm/inputs/RffSelectMultipleUserEmailField";
import RffGroup from "../../finalForm/shared/RffGroup";
import Flx from "../../layout/Flx";
import BasicModal from "../../modals/BasicModal";
import AvatarStackWithAction from "../../ui/AvatarStackWithAction";

const LoanPermittedUsersAvatarStack = ({ children }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const { updateLoanPermittedUsers, loading } = useUnderwritingHook();
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users);
  const [show, setShow] = useState(false);

  const permittedUsersNamesString = useMemo(() => {
    const permittedUsers = loanDrilldown?.permittedUsers;
    if (isEmpty(permittedUsers)) {
      return "None";
    }

    const permittedUsersFullnames = permittedUsers.map((user) => {
      return getUserFullNameFromEmail(users, user);
    });

    return permittedUsersFullnames.join(", ");
  }, [loanDrilldown?.permittedUsers, users]);

  const permittedUsersFullNames = useMemo(() => {
    const permittedUsers = loanDrilldown?.permittedUsers;
    if (isEmpty(permittedUsers)) {
      return [];
    }
    return permittedUsers.map((user) => {
      return getUserFullNameFromEmail(users, user);
    });
  }, [loanDrilldown?.permittedUsers, users]);

  const initialValues = useMemo(() => {
    return {
      permittedUsers: loanDrilldown?.permittedUsers || [],
    };
  }, [loanDrilldown?.permittedUsers]);

  const onSubmit = (values) => {
    const updatedPermittedUsers = values?.permittedUsers;
    updateLoanPermittedUsers({
      loanId: loanDrilldown?._id,
      permittedUsers: updatedPermittedUsers,
      onSuccessFn: (res) => {
        dispatch(loanDrilldownSet(res));
        setShow(false);
      },
    });
  };

  return (
    <>
      <AvatarStackWithAction
        label="Permitted Users"
        onAddClick={() => setShow(true)}
        onAddTooltip="Add permitted users to view this loan"
        items={permittedUsersFullNames}
      />

      <BasicModal
        show={show}
        onClose={() => setShow(false)}
        title="Permitted Users"
        maxWidth="md"
      >
        <Flx column gap={1} sx={{ mt: 1, mb: 3 }}>
          <RffDisplayField
            label={`Current Permitted Users (${size(loanDrilldown?.permittedUsers)})`}
            value={permittedUsersNamesString}
          />
        </Flx>
        <Divider sx={{ mb: 3 }} />
        <RffForm
          loading={loading}
          onSubmit={onSubmit}
          submitText="Add User"
          initialValues={initialValues}
        >
          <RffGroup>
            <RffSelectMultipleUserEmailField
              name="permittedUsers"
              displayFullLabel
              label="Select user to add to loan"
            />
          </RffGroup>
        </RffForm>
      </BasicModal>
    </>
  );
};

export default LoanPermittedUsersAvatarStack;
